var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSampletest15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.44 47.4",
    enableBackground: "new 0 0 42.44 47.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M17.49,47.4H7.88C3.53,47.4,0,43.86,0,39.52V7.88C0,3.53,3.53,0,7.88,0h21.59c4.34,0,7.88,3.53,7.88,7.88 v19.4c0,0.93-0.75,1.67-1.67,1.67c-0.93,0-1.67-0.75-1.67-1.67V7.88c0-2.5-2.03-4.53-4.53-4.53H7.88c-2.5,0-4.53,2.03-4.53,4.53 v31.64c0,2.5,2.03,4.53,4.53,4.53h9.61c0.93,0,1.67,0.75,1.67,1.67C19.17,46.64,18.41,47.4,17.49,47.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M28.37,14.75H9.06c-0.93,0-1.67-0.75-1.67-1.67c0-0.93,0.75-1.67,1.67-1.67h19.32 c0.93,0,1.67,0.75,1.67,1.67C30.05,14,29.3,14.75,28.37,14.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M28.37,22.27H9.06c-0.93,0-1.67-0.75-1.67-1.67c0-0.93,0.75-1.67,1.67-1.67h19.32 c0.93,0,1.67,0.75,1.67,1.67C30.05,21.51,29.3,22.27,28.37,22.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M20.68,29.79H9.06c-0.93,0-1.67-0.75-1.67-1.67c0-0.93,0.75-1.67,1.67-1.67h11.63 c0.93,0,1.67,0.75,1.67,1.67C22.36,29.03,21.6,29.79,20.68,29.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M29.02,47.4c-0.77,0-1.52-0.28-2.11-0.79l-6.66-5.84c-0.69-0.61-0.76-1.67-0.16-2.36 c0.61-0.69,1.67-0.76,2.36-0.16l6.54,5.73l10.47-13.22c0.57-0.72,1.63-0.85,2.35-0.27c0.72,0.57,0.85,1.63,0.27,2.35L31.51,46.19 c-0.54,0.68-1.34,1.12-2.22,1.19C29.2,47.39,29.11,47.4,29.02,47.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampletest15);
export default __webpack_public_path__ + "static/media/Sample test-15.f6857b29e91809451ba783e9ff0ede3f.svg";
export { ForwardRef as ReactComponent };